import { IProductGroupSearchV2, ISearchResponse } from '@cbgms/api'

export const silentSearchErrors = ['ErrHBaseVINLookupServiceTimeout', 'ErrMDMLookupServiceTimeout']

export function useFilterSilentSearchErrors(searchResponse: ISearchResponse | IProductGroupSearchV2 | undefined) {
  return (searchResponse?.Errors || []).filter(e => !silentSearchErrors.includes(e.Err))
}

export function useGetSilentSearchErrors(searchResponse: ISearchResponse | IProductGroupSearchV2 | undefined) {
  return (searchResponse?.Errors || []).filter(e => !!silentSearchErrors.includes(e.Err))
}
